/**
 * Product Sticky Add To Cart
 */

const productStickyAddToCart = () => {
  const config = {
    class: {
      fadeIn: "fade-in",
      pdpFadeIn: "pdp-fade-in",
    },
    dom: {
      header: ".product-form-container",
      stickyAtcCont: ".sticky-atc",
      currentPriceWrap:
        ".product__info-wrapper span.price-item.price-item--regular",
      currentPriceRangeWrap:
        ".product__info-wrapper div.price-range span.price-item",
      atcPriceCont: ".sticky_atc_price",
      unitStickyPrice: ".sticky_atc_price_ut",
      yotpoSubsInSticky:
        ".product-form__buttons-sticky-atc .yotpo-widget-subscriptions-add-to-cart",
      stickyAtcBtn: ".product-form__submit-atc",
    },
    event: {
      click: "click",
      scroll: "scroll",
      resize: "resize",
      onload: "onload",
    },
  };

  const $root = document.documentElement;
  const $bodyClass = document.querySelector('body')
  const $header = document.querySelector(config.dom.header);
  const $stickyAtcCont = document.querySelector(config.dom.stickyAtcCont);
  const $yotpoSubsInSticky = document.querySelector(
    config.dom.yotpoSubsInSticky
  );
  const $stickyAtcBtn = document.querySelector(config.dom.stickyAtcBtn);

  if (typeof $yotpoSubsInSticky != "undefined" && $yotpoSubsInSticky != null) {
    $yotpoSubsInSticky.remove();
  }

  if ($stickyAtcBtn) {
    $stickyAtcBtn.addEventListener(config.event.click, () => {
      document.querySelector("button.product-form__submit--product-info").click();
    });
  }

  /**
   * Add Class on Scroll
   */
  const addClassOnScroll = () => {
    $stickyAtcCont.classList.add(config.class.fadeIn);
    $root.classList.add(config.class.pdpFadeIn);
    $bodyClass.classList.add(config.class.pdpFadeIn);
  };

  /**
   * Remove Class on Scroll
   */
  const removeClassOnScroll = () => {
    $stickyAtcCont.classList.remove(config.class.fadeIn);
    $root.classList.remove(config.class.pdpFadeIn);
    $bodyClass.classList.remove(config.class.pdpFadeIn);
  };

  /**
   * Sticky ATC State
   */
  const sitckyAtcState = () => {
  const scrollpos = window.scrollY;
  const headerScrollY = $header.offsetTop + $header.clientHeight;

  if (scrollpos >= headerScrollY) {
    addClassOnScroll();
  } else {
    removeClassOnScroll();
  }
};

  window.addEventListener(config.event.scroll, sitckyAtcState);
  window.addEventListener(config.event.resize, sitckyAtcState);
  window.addEventListener(config.event.onload, sitckyAtcState);
};

productStickyAddToCart();

// Sticky ATC Bar Variant Pull and Price
const stickyVariant = document.querySelector('fieldset.product-form__input')

let selectedPricePerltr = [];
const stickyAtcBtn = document.querySelector(".product-form__submit-atc");

stickyVariant.addEventListener('change', event => {
  if (event.target.type === 'radio') {
    const checked = document.querySelectorAll('input[type=radio]:checked')
    const atcPricePerLtr = document.querySelectorAll('input[type=radio]:checked + .product-variant__label .price-per-liter')

    selectedPricePerltr = Array.from(atcPricePerLtr).map(x => x.innerText)
    const atcVariant = document.querySelector(".atc-variant");
    if (atcVariant) {
      atcVariant.innerHTML = event.target.defaultValue;
    }
    const unitPriceSelector = document.querySelector(
      ".sticky-atc-price-perliter"
    );
    if (unitPriceSelector) {
      unitPriceSelector.innerText = selectedPricePerltr;
    }
    const selectedVariant = event.target;
    let variantPrice = selectedVariant.dataset.variantPrice || "";
    const isAvailable = selectedVariant.dataset.available === "true";

    if (variantPrice.includes("ש")) {
      variantPrice = variantPrice.replace("ש", 'ש"ח');
    }
    const priceClassSelector = document.querySelector(".sticky_atc_price_ut");
    if (priceClassSelector) {
      priceClassSelector.innerText = variantPrice;
    }
    const btnPriceSelector = document.querySelector(".sticky_atc_price");
    if (btnPriceSelector) {
      btnPriceSelector.innerText = "| " + variantPrice;
    }
    // when the variant change then update addtocart text in the sticky bar on the PDP page
    if (stickyAtcBtn) {
      const addToCartText = stickyAtcBtn.getAttribute("data-add-to-cart-text");
      const soldOutText = stickyAtcBtn.getAttribute("data-sold-out-text");

      if (isAvailable) {
        stickyAtcBtn.classList.remove("button--disabled");
        stickyAtcBtn.removeAttribute("disabled");
        stickyAtcBtn.querySelector(".sticky_atc_state").textContent =
          addToCartText;
      } else {
        stickyAtcBtn.classList.add("button--disabled");
        stickyAtcBtn.setAttribute("disabled", "disabled");
        stickyAtcBtn.querySelector(".sticky_atc_state").textContent = soldOutText;
      }
    }
  }
})
